import { LoggerCheckResponse, LoggerId, RunLoggerCheckParams } from '../types/Logger';
import { client } from './Client';

export const runLoggerCheck = async ({
    scanId,
    boxId,
    queryParams,
    payload
}: RunLoggerCheckParams): Promise<LoggerCheckResponse> => {
    let url = '/checks';
    if (boxId) {
        url += `/scans/${scanId}/box/${boxId}`;
    } else if (scanId) {
        url += `/scans/${scanId}`;
    }

    return client.post(url, payload, { params: queryParams }).then((response) => response.data);
};

export type DeleteChecks = {
    scanId: string;
    boxId: string | undefined;
    payload: { loggerIds: Array<LoggerId>; useCachedResults?: boolean };
};

export const deleteChecks = async ({ scanId, boxId, payload }: DeleteChecks): Promise<void> => {
    let url = `/checks/scans/${scanId}`;
    if (boxId) {
        url += `/box/${boxId}`;
    }
    return client.delete(url, { data: payload });
};
